import { MuiTheme } from "theme";
import { makeStyles } from "@material-ui/core/styles";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: MuiTheme) => ({
  flaggedInfo: {
    [theme.breakpoints.down(Breakpoints.XS_420)]: {
      fontSize: 12
    }
  }
}));
